@if (first(); as f) {
  @if (f.attribute === 'file' || f.attribute === 'image') {
    {{ entityName() }} [{{ attributeName() }}] :
    @for (d of details(); track d.id) {
      <ces-value-change [detail]="d" />
    }
  } @else if (f.attribute === 'choice_value') {
    {{ 'history.logContent.choice' | transloco }} "{{ entityName() }}" :<br />
    <ces-value-change [detail]="f" />
  } @else if (f.attribute === 'text_value') {
    @if (truncatedDetail(); as td) {
      {{ 'history.logContent.text' | transloco }} "{{ entityName() }}" :<br />
      <ces-value-change [detail]="td" />
    }
  } @else if (f.attribute === 'planned') {
    {{ 'history.entities.auscultation' | transloco }} "{{ entityName() }}", "{{ attributeName() }}" :
    <ces-value-change [detail]="f" />
  } @else if (!isSpecialAttribute()) {
    {{ entityName() }} [{{ attributeName() }}] :
    <ces-value-change [detail]="f" />
  }
}
